module.exports = __webpack_public_path__ + "static/media/SCBproducts.88270a43.svg";